module.exports = __webpack_public_path__ + "static/img/link2.69fdf543.png";